import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref } from "vue"

import { computed } from 'vue';
import { useStore } from 'vuex';
import { Banner } from '@components/Banner';
import FleetMigrationGuideLink from '@shell/components/fleet/FleetMigrationGuideLink.vue';
import PaginatedResourceTable from '@shell/components/PaginatedResourceTable.vue';
import RichTranslation from '@shell/components/RichTranslation.vue';
import { FLEET } from '@shell/config/types';
import { NAME as FLEET_PRODUCT } from '@shell/config/product/fleet';
import { BLANK_CLUSTER } from '@shell/store/store-types';


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
  // ResourceList decides who owns fetching the rows by looking for PaginatedResourceTable in the
  // components option, which <script setup> does not populate.
  components:   { PaginatedResourceTable },
},
  __name: 'fleet.cattle.io.gitreporestriction',
  props: {
    schema: {},
    useQueryParamsForSimpleFiltering: { type: Boolean, default: false }
  },
  setup(__props: any) {





const store = useStore();

// In-app link to the new Fleet Policies list (the successor to GitRepoRestriction).
const policiesLocation = {
  name:   'c-cluster-product-resource',
  params: {
    cluster: BLANK_CLUSTER, product: FLEET_PRODUCT, resource: FLEET.POLICY
  },
};

// The Policies list is only reachable where Fleet serves the Policy type (the nav entry is schema
// gated too), so fall back to plain text rather than linking to a resource-not-found page.
const hasPolicySchema = computed(() => !!store.getters['management/schemaFor'](FLEET.POLICY));

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Banner), {
      color: "warning",
      "data-testid": "git-repo-restriction-deprecation-banner"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(RichTranslation, {
            k: "fleet.restrictions.deprecationWarning",
            tag: "div"
          }, {
            policiesLink: _withCtx(({ content }) => [
              (hasPolicySchema.value)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: policiesLocation
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(content), 1)
                    ]),
                    _: 2
                  }, 1024))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(content), 1)
                  ], 64))
            ]),
            _: 1
          }),
          _cache[0] || (_cache[0] = _createTextVNode()),
          _createVNode(FleetMigrationGuideLink, { class: "mt-5" })
        ])
      ]),
      _: 1
    }),
    _cache[1] || (_cache[1] = _createTextVNode()),
    _createVNode(PaginatedResourceTable, {
      schema: __props.schema,
      "use-query-params-for-simple-filtering": __props.useQueryParamsForSimpleFiltering
    }, null, 8, ["schema", "use-query-params-for-simple-filtering"])
  ]))
}
}

})